import firebase from 'firebase';

import View from '../../../_components/view/view.js';
import groupTpl from './group.tpl.html';
import './group.styles.less';

import GroupPlayerView from './group-player/group-player.view.js';
import AddPlayerToGroupModal from './_modals/add-player-to-group-modal/add-player-to-group.modal.js';

class GroupView extends View {

	constructor (data, options) {
		super(groupTpl, data, options);

		this.groupPlayerViews = [];
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			playersList: '.players-list',
			btnAddPlayer: '.btn-add-player',
			btnDeleteGroup: '.btn-delete-group'
		});
	}

	render(data) {
		super.render(data);
		
		this.getGroupPlayers();
	}

	initializeEvents() {
		this.ui.btnAddPlayer.click(() => this.addPlayer());
		this.ui.btnDeleteGroup.click(() => this.deleteGroup());
	}

	getGroupPlayers() {
		firebase.database().ref('players/')
			.orderByChild('groupId')
			.equalTo(this.options.__group.key)
			.on('value', __players => {
				this.updatePlayersList(__players);
			});
	}

	updatePlayersList(__players) {
		this.removePlayersList();

		__players.forEach( __player => {
			let	groupPlayerView = new GroupPlayerView(__player.val(), {__player: __player});
			this.groupPlayerViews.push(groupPlayerView);
			groupPlayerView.appendTo(this.ui.playersList);
		});

		if (__players.val()) {
			this.ui.btnDeleteGroup.addClass('hidden');
		} else {
			this.ui.btnDeleteGroup.removeClass('hidden');
		}
	}

	removePlayersList() {
		_.forEach(this.groupPlayerViews, groupPlayerView => {
			groupPlayerView.remove();
		});

		this.groupPlayerViews = [];
	}

	addPlayer() {
		firebase.database().ref('players/')
			.orderByChild('groupId')
			.equalTo(null)
			.once('value', __players => {
			new AddPlayerToGroupModal(
				this.options.__group.key,
				__players
			).open().then( () => {
				
			});
		});
	}

	deleteGroup() {
		this.options.__group.ref.remove();
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
	}

}

export default GroupView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/groups/group/group.view.js